import { type WorkspacesService } from '../modules/workspace';

/**
 * Create a new workspace with the given name.
 * Onboarding content is backend-seeded during createWorkspace (sl-u4d2).
 *
 * @param locale BCP-47 language tag forwarded to the backend so the
 * onboarding doc title + tutorial-card strings render in the user's
 * UI language. Backend validates and falls back to 'en'.
 */
export async function buildShowcaseWorkspace(
  workspacesService: WorkspacesService,
  flavour: string,
  workspaceName: string,
  locale?: string
) {
  const meta = await workspacesService.create(
    flavour,
    async docCollection => {
      docCollection.meta.initialize();
      docCollection.doc.getMap('meta').set('name', workspaceName);
    },
    workspaceName,
    locale
  );

  return { meta };
}
